import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PrivacyPolicyScreen = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <div className="bg-primary text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl lg:text-5xl font-sofia font-bold mb-4">
            {t('privacy.title')}
          </h1>
          <p className="text-xl font-sofia opacity-90">
            {t('privacy.subtitle')}
          </p>
          <p className="text-sm font-sofia opacity-75 mt-4">
            {t('privacy.lastUpdated')}: {t('privacy.updateDate')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          
          {/* Introduction */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.introduction.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed mb-4">
              {t('privacy.introduction.content')}
            </p>
          </section>

          {/* Information We Collect */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.informationCollected.title')}
            </h2>
            
            <h3 className="text-xl font-sofia font-semibold text-text-primary mb-4">
              {t('privacy.informationCollected.personal.title')}
            </h3>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed mb-6 space-y-2">
              {t('privacy.informationCollected.personal.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3 className="text-xl font-sofia font-semibold text-text-primary mb-4">
              {t('privacy.informationCollected.automatic.title')}
            </h3>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed mb-6 space-y-2">
              {t('privacy.informationCollected.automatic.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* How We Use Information */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.howWeUse.title')}
            </h2>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('privacy.howWeUse.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Information Sharing */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.informationSharing.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed mb-4">
              {t('privacy.informationSharing.content')}
            </p>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('privacy.informationSharing.exceptions', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Data Security */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.dataSecurity.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('privacy.dataSecurity.content')}
            </p>
          </section>

          {/* Your Rights */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.yourRights.title')}
            </h2>
            <ul className="list-disc list-inside text-text-secondary font-sofia leading-relaxed space-y-2">
              {t('privacy.yourRights.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* Cookies */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.cookies.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed">
              {t('privacy.cookies.content')}
            </p>
          </section>

          {/* Contact */}
          <section className="mb-12">
            <h2 className="text-2xl font-sofia font-bold text-primary mb-6">
              {t('privacy.contact.title')}
            </h2>
            <p className="text-text-secondary font-sofia leading-relaxed mb-4">
              {t('privacy.contact.content')}
            </p>
            <div className="bg-background p-6 rounded-lg">
              <p className="font-sofia text-text-primary">
                <strong>Email:</strong> {t('contact.email')}
              </p>
              <p className="font-sofia text-text-primary">
                <strong>{t('contact.phone.title')}:</strong> {t('contact.phone.morocco')}
              </p>
            </div>
          </section>

        </div>

        {/* Back to Home */}
        <div className="text-center mt-12">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-accent text-white font-sofia font-medium rounded-lg hover:bg-accent/90 transition-colors duration-200"
          >
            {t('common.backToHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyScreen;
